document.addEventListener('DOMContentLoaded', function () {
  var container = document.querySelector('[data-cart-recommendations]');
  if (!container) return;

  var url = container.getAttribute('data-url');
  if (!url) return;

  fetch(url)
    .then(function (response) {
      return response.text();
    })
    .then(function (text) {
      var temp = document.createElement('div');
      temp.innerHTML = text;
      var fetchedGrid = temp.querySelector('[data-cart-recommendations]');

      if (fetchedGrid && fetchedGrid.innerHTML.trim().length) {
        container.innerHTML = fetchedGrid.innerHTML;
      }
      // If empty, the server-rendered fallback (other products from
      // the seed product's own collection, excluding what's already
      // in cart) stays as-is.
    })
    .catch(function () {
      // Fetch failed — leave the fallback content in place.
    });
});